import type {
  DashboardRequest,
  DashboardResponse,
  SourcesResponse,
} from "../shared/contracts";
import { getAuthToken } from "./auth-storage";

const API_BASE =
  import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") ||
  "http://localhost:8787";

export async function requestJson<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "content-type": "application/json",
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  });

  const body = await response.json().catch(() => null);

  if (!response.ok) {
    const message =
      body && typeof body === "object" && "message" in body
        ? String(body.message)
        : `La API respondió con ${response.status}`;
    throw new Error(message);
  }

  return body as T;
}

export function fetchDashboard(input: DashboardRequest) {
  return requestJson<DashboardResponse>("/api/dashboard/url", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function fetchSources() {
  return requestJson<SourcesResponse>("/api/config/sources");
}
